import React, { useEffect, useState } from "react";
import "../../global.css";
import "./home.css";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";
import { IoReorderThreeOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import ContentCard from "../../components/contentcard/ContentCard";
import { useSelector, useDispatch } from "react-redux";
import { setContent, setIsOpenContentsModal } from "../../redux/contentSlice";
import { useTranslate } from "../../utils/useTranslate";

const Home = () => {
  const translate = useTranslate();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const { content, isOpenContentsModal } = useSelector(
    (state) => state.content
  );

  const [contents, setContents] = useState([]);

  const { language } = useSelector((state) => state.language);

  useEffect(() => {
    if (language.value === "en") {
      fetch("/assets/datas/contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    } else {
      fetch("/assets/datas/tr-contents.json")
        .then((res) => res.json())
        .then((data) => {
          setContents(data);
        });
    }
  }, [language]);

  useEffect(() => {
    if (!content && contents.length > 0) {
      dispatch(setContent(contents[0]));
    } else if (contents.length > 0) {
      const newContent = contents.find(
        (item) => content?.id === item?.id || content?.id === item?.altId
      );

      if (!newContent) return;

      if (newContent.altId === content.id) {
        const newItem = {
          id: newContent.altId,
          title: newContent.altTitle,
          subTitle: newContent.altSubTitle,
          description: newContent.altDescription,
          image: newContent.altImage,
          url: newContent.altUrl,
        };

        if (JSON.stringify(newItem) !== JSON.stringify(content)) {
          dispatch(setContent(newItem));
        }
      } else if (JSON.stringify(newContent) !== JSON.stringify(content)) {
        dispatch(setContent(newContent));
      }
    }
  }, [contents, dispatch, content]);

  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    // content değiştiğinde animasyonu başlatmak için key'i artırıyoruz
    setAnimationKey((prevKey) => prevKey + 1);
  }, [content]);

  return (
    <div className="globalContainer homeContainer">
      <div
        className="homeLeftContainer"
        style={{
          width: isOpenContentsModal === false && isMobile === false && "96%",
        }}
        key={animationKey}
      >
        <div className="homeLeftSubContainer">
          <img
            className="homeLeftImage"
            alt=""
            src={`/assets/images/${content?.image}`}
          />
          <div className="homeLeftBottomDiv">
            <div className="homeLeftBottomLeftDiv">
              <div className="homeLeftBottomLeftSubDiv">
                <span className="textFlex titleTextStyle">
                  {language.value === "tr"
                    ? content?.title.toLocaleUpperCase("tr-TR")
                    : content?.title.toLocaleUpperCase("en-US")}
                </span>
                <hr className="homeLeftDivHr" />
                <span className="textMono subTitleTextStyle">
                  {language.value === "tr"
                    ? content?.subTitle.toLocaleUpperCase("tr-TR")
                    : content?.subTitle.toLocaleUpperCase("en-US")}
                </span>
              </div>
              <span className="textFlex descriptionTextStyle">
                {content?.description}
              </span>
              <div
                className="homeLeftBottomLeftRightDiv"
                onClick={
                  () =>
                    content.id === 1
                      ? navigate("/visualnarratives")
                      : content.id === 2
                      ? navigate("/auditorynarratives")
                      : content.id === 3
                      ? navigate("/textualnarratives")
                      : null
                  // window.open(
                  //     content.url,
                  //     "_blank",
                  //     "noopener,noreferrer"
                  //   )
                }
              >
                <span className="text seeAllTextStyle">
                  {language.value === "tr"
                    ? translate("seeAll").toLocaleUpperCase("tr-TR")
                    : translate("seeAll").toLocaleUpperCase("en-US")}
                  <FaArrowRight />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOpenContentsModal === true && isMobile === false ? (
        <div className="homeRightContainer">
          <div className="homeRightSubContainer">
            <span className="textMono allContentTextStyle">
              {language.value === "tr"
                ? translate("allContent").toLocaleUpperCase("tr-TR")
                : translate("allContent").toLocaleUpperCase("en-US")}
            </span>
            <hr className="homeRightDivHr" />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              height: "75vh",
              gap: "10px",
            }}
          >
            {contents.map((item) => (
              <ContentCard
                item={item}
                isHome={true}
                isMobile={false}
                key={item.id}
              />
            ))}
          </div>
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("allContent").toLocaleUpperCase("tr-TR")
                  : translate("allContent").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : isMobile === true && isOpenContentsModal === false ? (
        <div className="homeRightContainer">
          {isMobile && (
            <button
              className="allContentMobileStyle"
              style={{ textDecoration: "none" }}
              onClick={() => dispatch(setIsOpenContentsModal(true))}
            >
              <IoReorderThreeOutline
                style={{ fontSize: "18px", color: "#100F0D" }}
              />
              <span className="linkTextStyle textMono">
                {language.value === "tr"
                  ? translate("allContent").toLocaleUpperCase("tr-TR")
                  : translate("allContent").toLocaleUpperCase("en-US")}
              </span>
            </button>
          )}
        </div>
      ) : (
        isMobile === true &&
        isOpenContentsModal === true && (
          <div className="customModalOverlay">
            <div className="customModalContainer">
              <div
                className="homeRightContainer"
                style={{
                  height: "70vh",
                }}
              >
                <div className="homeRightSubContainer">
                  <span className="textMono allContentTextStyle">
                    {language.value === "tr"
                      ? translate("allContent").toLocaleUpperCase("tr-TR")
                      : translate("allContent").toLocaleUpperCase("en-US")}
                  </span>
                  <hr className="homeRightDivHr" />
                </div>
                <div className="modalScrollableContent">
                  {contents.map((item) => (
                    <ContentCard
                      item={item}
                      isHome={true}
                      isMobile={true}
                      key={item.id}
                    />
                  ))}
                </div>

                {isMobile && (
                  <button
                    className="allContentMobileStyle"
                    style={{ textDecoration: "none" }}
                    onClick={() => dispatch(setIsOpenContentsModal(false))}
                  >
                    <IoCloseOutline
                      style={{ fontSize: "18px", color: "#100F0D" }}
                    />
                    <span className="linkTextStyle textMono">
                      {language.value === "tr"
                        ? translate("allContent").toLocaleUpperCase("tr-TR")
                        : translate("allContent").toLocaleUpperCase("en-US")}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default Home;
